import _ from 'lodash'

import {
  FETCH_TOUR_DETAILS_BEGIN,
  FETCH_TOUR_DETAILS_SUCCESS,
  FETCH_TOUR_DETAILS_ERROR,
  FETCH_TRAINS_SUCCESS,
} from '../actions/fetchTourDetails'

import { brandCurrencyTypes } from '../../configuration/brand'
import { formatTourPricingForMobileLayout } from '../../utilities/content/tours'

const initialState = {
  loading: false,
  error: null,
  data: null,
}

export default function fetchTourDetails(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOUR_DETAILS_BEGIN:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_TOUR_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload,
      })
    case FETCH_TOUR_DETAILS_ERROR:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
      })
    case FETCH_TRAINS_SUCCESS:
      return Object.assign({}, state, {
        data: {
          ...state.data,
          trains: action.payload,
        }
      })
    default:
      return state
  }
}

export const tourDetailsData = (state) => state.tourDetailsData
export const getTourDetailsLoading = (state) => state.tourDetailsData.loading
export const getAdvertisedPrice = (state) =>
  _.get(state, 'tourDetailsData.data.advertisedPrice')
export const getTour = state => _.get(state, 'tourDetailsData.data')
export const getTourTitle = (state) => _.get(state, 'tourDetailsData.data.name')
export const getTourItinerary = (state) => {
  return _.get(state, 'tourDetailsData.data')
}

export const getClosestAvailableDepartureDate = (state) => {
  const availability = _.get(
    state,
    'tourDetailsData.data.availability[0].pricing',
    {}
  )
  const sortedDepartureDates = _.orderBy(
    _.map(availability, (option, key) => key)
  )
  // find first date that does not have a closed or sold out status
  const firstAvailableDate = _.find(sortedDepartureDates, (date) => {
    const saleStatus = _.get(availability, `[${date}].saleStatus`)
    return saleStatus !== 'C' && saleStatus !== 'S'
  })
  return firstAvailableDate ? new Date(firstAvailableDate) : null
}

export const getAdvertisedTourPrice = (state) => {
  const price = _.get(state, 'tourDetailsData.data.advertisedPrice')
  return price && price.toLocaleString()
}

export const getTourMarketingURL = (state) => {
  return _.get(state, 'tourDetailsData.data.marketingUrl')
}

export const isSoftTripBooking = (state) => {
  return _.get(state, 'tourDetailsData.data.softripBooking')
}

export const getTourDetailsForSoftTrip = (state) => {
  const brand = _.get(state, 'configurationData.data.brand')
  return {
    ProductCode: _.get(state, 'tourDetailsData.data.id'),
    Theme: brand,
    QC: brandCurrencyTypes[brand],
    SessID: '',
    Action: isSoftTripBooking(state) ? 'SelectPackage' : 'SeqList',
  }
}

export const getTourDetailsForSoftripGetaway = (state) => {
  const tour = getTour(state)
  const baseDetails = getTourDetailsForSoftTrip(state)
  const firstAvailablePricingCategory = _.get(tour, 'availability[0]')
  const availableDates = _.get(firstAvailablePricingCategory, 'pricing')
  const firstAvailableTourDate = _.find(availableDates, date => {
    // find first date that is not closed or sold out
    return date.saleStatus !== 'C' && date.saleStatus !== 'S'
  })
  return {
    ...baseDetails,
    ItemNumber: _.get(firstAvailablePricingCategory, 'id'),
    SelectedSeq: _.get(firstAvailablePricingCategory, 'id'),
    tbCheckIn: _.get(firstAvailableTourDate, 'date')
  }
}

export const getTourBookingPath = (state) => {
  return isSoftTripBooking(state)
    ? process.env.REACT_APP_GETAWAY_BOOKING_PATH
    : process.env.REACT_APP_PACKAGE_BOOKING_PATH
}

export const getTourAccommodationOptions = (state) => {
  const preAcc = _.get(state, 'tourDetailsData.data.preAccommodations')
  const postAcc = _.get(state, 'tourDetailsData.data.postAccommodations')
  return {
    ...(preAcc && { preAcc }),
    ...(postAcc && { postAcc }),
  }
}

export const getAvailabilityForMobileLayout = (state) => {
  const tourAvailability = _.get(state, 'tourDetailsData.data.availability', [])
  return formatTourPricingForMobileLayout(tourAvailability)
}
